import React, { Component } from 'react';

class PasswordRequirements extends Component {
  render() {
    return (
      <div
        className="modal fade theme-modal" id="passwordRequirements"
        tabIndex="-1" aria-labelledby="passwordRequirementsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="passwordRequirementsModalLabel">Password Requirements</h5>
              <p>Must be at least 8 characters long. Must contain an uppercase letter,
                a lowercase letter, a number and a special character. Password cannot be reused.
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PasswordRequirements;
